import Vue from 'vue';
import App from './App.vue';
import router from './router';

import HeaderMenu from './components/homeModule/headerComponent/headerComponent.vue';
import FilterNav from './components/homeModule/searchNavComponent/searchNavComponent.vue';
import Footer from './components/homeModule/footerComponent/footerComponent.vue';
import Left from './components/homeModule/leftComponent/leftComponent.vue';
import Right from './components/homeModule/rightComponent/rightComponent.vue';

import scss from './content/scssStyles.scss';
import { store } from "./store/store";
import datePickerComponent from "./components/datePicker/datePicker.vue";
import pageLoadingComponent from "./components/pageLoadingComponent/pageLoading.vue";

import timepicker from './components/timePickerGridView/timePickerGridView.vue';
import vueSlider from './components/sliderComponent/vue-slider/';
import DateRangePicker from './components/DateRangePicker/components/DateRangePicker';
import availabilitySummary from './components/availabilitySearch/availabilitySummary/availabilitySummary.vue';
import unitDetailPage from './components/availabilitySearch/unitDetailPage.vue';

import googleMaps from './components/googleMapsComponent/googleMapsComponent.vue';
import addMarker from './components/googleMapsComponent/addMarker.vue';

// import GoogleAutocomplete from './components/GoogleAutocomplete/GoogleAutocomplete.vue';
import VueGoogleAutocomplete from './components/VueGoogleAutocomplete.vue';
import VueAnalytics from 'vue-analytics';
import * as axios from 'axios';


// import Vue from 'vue'
import VueObserveVisibility from 'vue-observe-visibility'
 
Vue.use(VueObserveVisibility)

// import { Tooltip, VPopover, VClosePopover } from 'v-tooltip'

// import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
  defaultHtml: false,
})

// Vue.directive('tooltip', Tooltip)
// Vue.directive('close-popover', VClosePopover)
// Vue.component('v-popover', VPopover)


Vue.component(DateRangePicker.name, DateRangePicker);
Vue.component(pageLoadingComponent.name, pageLoadingComponent);
Vue.component(timepicker.name, timepicker);
Vue.component(datePickerComponent.name, datePickerComponent);
Vue.component(vueSlider.name, vueSlider)
Vue.component(availabilitySummary.name, availabilitySummary);
Vue.component(unitDetailPage.name, unitDetailPage);
Vue.component(googleMaps.name, googleMaps);
Vue.component(addMarker.name, addMarker);
// Vue.component(GoogleAutocomplete.name, GoogleAutocomplete);
Vue.component(VueGoogleAutocomplete.name, VueGoogleAutocomplete);


new Vue({
  el: '#app',
  //render: h => h(App),
  router,
  template: '<App/>',
  store,
  components: { App }
});

new Vue({
  el: '#headerMenu',
  //render: h => h(App),
  router,
  template: '<HeaderMenu/>',
  store,
  bus: "bus",
  components: { HeaderMenu }
});


new Vue({
  el: '.footerCom',
  router,
  template: '<Footer/>',
  store,
  bus: "bus",
  components: { Footer }
});

new Vue({
  el: '#leftMenuPanel',
  router,
  template: '<Left/>',
  store,
  bus: "bus",
  components: { Left }
});
new Vue({
  el: '#rightMenuPanel',
  router,
  template: '<Right/>',
  store,
  bus: "bus",
  components: { Right }
});


new Vue({
  el: '.booking-eng',
  //render: h => h(App),
  router,
  template: '<FilterNav/>',
  store,
  bus: "bus",
  components: { FilterNav }
});

// let apiIp = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : '');
// let apiHttpRequest = function (apiUrl, type, params, successCallback, failureCallback) {
//   let url = apiIp + "/" + apiUrl;
//   params.systemParams = {
//     token: window.localStorage.getItem('betoken'),
//     Source: "Web",
//     SourceId: window.location.hostname,
//   }
//   axios.post(url, params)
//     .then(function (response) {
//       if (successCallback)
//         successCallback(response);
//     })
//     .catch(function (error) {
//       if (failureCallback)
//         failureCallback(error);
//     });
// };

let apiIp = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":1339" : '');
let url = apiIp +'/beApi/Get_BookingEngine_Config'

let params = {};
params.systemParams = {
    token: window.localStorage.getItem('betoken'),
    Source: "Web",
    SourceId: window.location.hostname,
  }
  import VueGtag from 'vue-gtag'




  let idsss = axios.post(url, params).then(response => {
    if (response && response.data) {
      console.log("response in Get_BookingEngine_Config", response);
      if (response.data[1] && response.data[1].length) {
        Vue.use(VueGtag, {
          config: { id: response.data[1][0].GACode }
          // debug: true
        })
      }
    }
  })


// id: axios.get('/beApi/Get_BookingEngine_Config').then(response => {
//   return response.data
// })



// WEBPACK FOOTER //
// ./src/main.js